var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFieldValidationNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_red",
    d: "M11.277 33.095l-1.806-1.806a1.167 1.167 0 010-1.649l19.604-19.604a1.167 1.167 0 011.649 0l1.806 1.806a1.167 1.167 0 010 1.649L12.926 33.095a1.167 1.167 0 01-1.649 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "SI_4L_fill_red",
    d: "M9.471 11.842l1.806-1.806a1.167 1.167 0 011.649 0L32.529 29.64a1.167 1.167 0 010 1.649l-1.806 1.806a1.167 1.167 0 01-1.649 0L9.471 13.491a1.165 1.165 0 010-1.649z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldValidationNegative);
export default __webpack_public_path__ + "static/media/fieldValidationNegative.145e5d7017c584de5644eda903d53e46.svg";
export { ForwardRef as ReactComponent };